/* eslint-disable @typescript-eslint/naming-convention */
import { Static, Type } from '@sinclair/typebox';
import { SurveyStates } from '../../enums/SurveyStates';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { createdResponse, removedResponse, updatedResponse } from '../../routes/defaultResponses';
import { taskDefinitionTableSchema } from './taskDefinitionTableSchema';

const getTaskDefinitionsSearchParametersSchema = Type.Object({
    status: Type.Optional(Type.Enum(SurveyStates)),
});

export type GetTaskDefinitionsSearchParametersSchema = Static<typeof getTaskDefinitionsSearchParametersSchema>;

export const taskDefinitionPaths = {
    '/api/settings/taskDefinitions': {
        get: {
            operationId: 'taskDefinitionControllers.getTaskDefinitions',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                items: Type.Array(Type.Intersect([Type.Pick(taskDefinitionTableSchema, ['id', 'name', 'order', 'surveyStatus'])])),
                            }),
                        },
                    },
                },
            },
            parameters: [
                {
                    name: 'searchParameters',
                    in: 'query',
                    schema: getTaskDefinitionsSearchParametersSchema,
                },
            ],
        },
        post: {
            operationId: 'taskDefinitionControllers.createTaskDefinition',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Pick(taskDefinitionTableSchema, ['name', 'order', 'surveyStatus']),
                    },
                },
            },
            responses: {
                ...createdResponse,
            },
        },
    },
    '/api/settings/taskDefinitions/{taskDefinitionId}': {
        parameters: [createPathGuidParameter('taskDefinitionId')],
        post: {
            operationId: 'taskDefinitionControllers.updateTaskDefinition',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Pick(taskDefinitionTableSchema, ['name', 'order', 'surveyStatus']),
                    },
                },
            },
            responses: {
                ...updatedResponse,
            },
        },
        delete: {
            operationId: 'taskDefinitionControllers.deleteTaskDefinition',
            responses: {
                ...removedResponse,
            },
        },
        get: {
            operationId: 'taskDefinitionControllers.getTaskDefinition',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Pick(taskDefinitionTableSchema, ['id', 'name', 'order', 'surveyStatus']),
                        },
                    },
                },
            },
        },
    },
} as const;
